/* eslint-disable */

// This is a generated file and SHOULD NOT BE EDITED MANUALLY!!
// Contents are generated as part of grunt build
// Source of truth is lib/cdo/global.rb and files in config/global/

export const RegionAr = {
  "locales": [
    "ar-SA"
  ],
  "locale_lock": true,
  "countries": [
    "BH",
    "IQ",
    "JO",
    "KW",
    "LB",
    "OM",
    "PS",
    "QA",
    "SA",
    "SY",
    "AE",
    "YE",
    "DZ",
    "EG",
    "LY",
    "MR",
    "MA",
    "SD",
    "TN"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/ar/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/ar/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/ar/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/ar/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/ar/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/ar/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/ar/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/ar/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/ar/privacy?_x_tr_sl=auto&_x_tr_tl=ar-SA&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/ar/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=ar-SA&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/ar/terms-of-service?_x_tr_sl=auto&_x_tr_tl=ar-SA&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/ar/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/ar/privacy?_x_tr_sl=auto&_x_tr_tl=ar-SA&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/ar/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=ar-SA&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/ar/terms-of-service?_x_tr_sl=auto&_x_tr_tl=ar-SA&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/en-us/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/ar/privacy?_x_tr_sl=auto&_x_tr_tl=ar-SA&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/ar/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=ar-SA&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/ar/terms-of-service?_x_tr_sl=auto&_x_tr_tl=ar-SA&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "ar-SA"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "ar-SA"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/ar/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionBr = {
  "locales": [
    "pt-BR"
  ],
  "locale_lock": true,
  "countries": [
    "BR"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/pt-BR/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/pt-BR/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/br/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/br/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/br/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/br/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/br/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/br/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/pt-BR/privacy?_x_tr_sl=auto&_x_tr_tl=pt-BR&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/pt-BR/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=pt-BR&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/pt-BR/terms-of-service?_x_tr_sl=auto&_x_tr_tl=pt-BR&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/br/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/pt-BR/privacy?_x_tr_sl=auto&_x_tr_tl=pt-BR&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/pt-BR/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=pt-BR&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/pt-BR/terms-of-service?_x_tr_sl=auto&_x_tr_tl=pt-BR&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/pt-BR/privacy?_x_tr_sl=auto&_x_tr_tl=pt-BR&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/pt-BR/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=pt-BR&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/pt-BR/terms-of-service?_x_tr_sl=auto&_x_tr_tl=pt-BR&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "pt-BR"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "pt-BR"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/br/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionCn = {
  "locales": [
    "zh-CN"
  ],
  "locale_lock": true,
  "countries": [
    "CN",
    "SG"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/zh-Hans/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/zh-Hans/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/cn/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/cn/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/cn/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/cn/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/cn/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/cn/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/zh-Hans/privacy?_x_tr_sl=auto&_x_tr_tl=zh-CN&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/zh-Hans/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=zh-CN&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/zh-Hans/terms-of-service?_x_tr_sl=auto&_x_tr_tl=zh-CN&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/cn/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/zh-Hans/privacy?_x_tr_sl=auto&_x_tr_tl=zh-CN&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/zh-Hans/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=zh-CN&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/zh-Hans/terms-of-service?_x_tr_sl=auto&_x_tr_tl=zh-CN&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/en-us/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/zh-Hans/privacy?_x_tr_sl=auto&_x_tr_tl=zh-CN&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/zh-Hans/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=zh-CN&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/zh-Hans/terms-of-service?_x_tr_sl=auto&_x_tr_tl=zh-CN&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "zh-CN"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "zh-CN"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/cn/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionCz = {
  "locales": [
    "cs-CZ"
  ],
  "locale_lock": true,
  "countries": [
    "CZ"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/cs/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/cs/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/cz/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/cz/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/cz/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/cz/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/cz/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/cz/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/cs/privacy?_x_tr_sl=auto&_x_tr_tl=cs-CZ&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/cs/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=cs-CZ&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/cs/terms-of-service?_x_tr_sl=auto&_x_tr_tl=cs-CZ&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/cz/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/cs/privacy?_x_tr_sl=auto&_x_tr_tl=cs-CZ&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/cs/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=cs-CZ&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/cs/terms-of-service?_x_tr_sl=auto&_x_tr_tl=cs-CZ&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/en-us/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/cs/privacy?_x_tr_sl=auto&_x_tr_tl=cs-CZ&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/cs/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=cs-CZ&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/cs/terms-of-service?_x_tr_sl=auto&_x_tr_tl=cs-CZ&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "cs-CZ"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "cs-CZ"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/cz/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionDe = {
  "locales": [
    "de-DE"
  ],
  "locale_lock": true,
  "countries": [
    "DE"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/de/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/de/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/de/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/de/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/de/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/de/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/de/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/de/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/de/privacy?_x_tr_sl=auto&_x_tr_tl=de-DE&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/de/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=de-DE&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/de/terms-of-service?_x_tr_sl=auto&_x_tr_tl=de-DE&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/de/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/de/privacy?_x_tr_sl=auto&_x_tr_tl=de-DE&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/de/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=de-DE&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/de/terms-of-service?_x_tr_sl=auto&_x_tr_tl=de-DE&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/en-us/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/de/privacy?_x_tr_sl=auto&_x_tr_tl=de-DE&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/de/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=de-DE&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/de/terms-of-service?_x_tr_sl=auto&_x_tr_tl=de-DE&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "de-DE"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "de-DE"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/de/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionEn = {
  "locales": [
    "en-US"
  ],
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "learn",
          "url": "/students",
          "domain": "code.org",
          "id": "header-learn"
        },
        {
          "title": "teach",
          "url": "/teach",
          "domain": "code.org",
          "id": "header-teach"
        },
        {
          "title": "districts",
          "url": "/administrators",
          "domain": "code.org",
          "id": "header-districts"
        },
        {
          "title": "stats",
          "url": "/promote",
          "domain": "code.org",
          "id": "header-stats"
        },
        {
          "title": "donate",
          "url": "/donate",
          "domain": "code.org",
          "id": "header-donate"
        },
        {
          "title": "incubator",
          "url": "/incubator",
          "domain": "code.org",
          "id": "header-incubator"
        },
        {
          "title": "about",
          "url": "/about",
          "domain": "code.org",
          "id": "header-about"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/students",
          "domain": "code.org",
          "id": "header-student-courses"
        },
        {
          "title": "project_gallery",
          "url": "/projects",
          "domain": "studio.code.org",
          "id": "header-student-projects"
        },
        {
          "title": "incubator",
          "url": "/incubator",
          "domain": "code.org",
          "id": "header-incubator"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "project_gallery",
          "url": "/projects",
          "domain": "studio.code.org",
          "id": "header-teacher-projects"
        },
        {
          "title": "professional_learning",
          "url": "/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        },
        {
          "title": "incubator",
          "url": "/incubator",
          "domain": "code.org",
          "id": "header-teacher-incubator"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "code.org",
          "url": "/students",
          "id": "learn"
        },
        {
          "title": "teach",
          "type": "expander",
          "id": "educate_entries",
          "subentries": [
            {
              "title": "educate_overview",
              "domain": "code.org",
              "url": "/teach",
              "id": "educate-overview"
            },
            {
              "title": "course_catalog",
              "url": "/students",
              "domain": "code.org",
              "id": "educate_courses"
            },
            {
              "title": "educate_elementary",
              "domain": "code.org",
              "url": "/educate/curriculum/elementary-school"
            },
            {
              "title": "educate_middle",
              "domain": "code.org",
              "url": "/educate/curriculum/middle-school"
            },
            {
              "title": "educate_high",
              "domain": "code.org",
              "url": "/educate/curriculum/high-school"
            },
            {
              "title": "educate_hoc",
              "url": "https://hourofcode.com"
            },
            {
              "title": "educate_beyond",
              "domain": "code.org",
              "url": "/educate/curriculum/3rd-party"
            },
            {
              "title": "educate_community",
              "url": "https://forum.code.org/"
            },
            {
              "title": "educate_requirements",
              "domain": "code.org",
              "url": "/educate/it"
            },
            {
              "title": "educate_tools",
              "domain": "code.org",
              "url": "/educate/resources/videos"
            }
          ]
        },
        {
          "title": "districts",
          "domain": "code.org",
          "url": "/administrators",
          "id": "districts"
        },
        {
          "title": "stats",
          "domain": "code.org",
          "url": "/promote",
          "id": "stats"
        },
        {
          "title": "donate",
          "domain": "code.org",
          "url": "/donate",
          "id": "donate"
        },
        {
          "title": "incubator",
          "url": "/incubator",
          "domain": "code.org",
          "id": "incubator"
        },
        {
          "title": "about",
          "type": "expander",
          "id": "about_entries",
          "subentries": [
            {
              "title": "about_us",
              "domain": "code.org",
              "url": "/about",
              "id": "about-us"
            },
            {
              "title": "about_leadership",
              "domain": "code.org",
              "url": "/about/leadership"
            },
            {
              "title": "about_donors",
              "domain": "code.org",
              "url": "/about/donors"
            },
            {
              "title": "about_partners",
              "domain": "code.org",
              "url": "/about/partners"
            },
            {
              "title": "about_team",
              "domain": "code.org",
              "url": "/about/team"
            },
            {
              "title": "about_news",
              "domain": "code.org",
              "url": "/about/news"
            },
            {
              "title": "about_jobs",
              "domain": "code.org",
              "url": "/about/jobs"
            },
            {
              "title": "about_contact",
              "domain": "code.org",
              "url": "/contact"
            },
            {
              "title": "about_faqs",
              "domain": "code.org",
              "url": "/faq"
            }
          ]
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "domain": "code.org",
              "url": "/privacy"
            },
            {
              "title": "legal_cookie_notice",
              "domain": "code.org",
              "url": "/cookies"
            },
            {
              "title": "legal_tos",
              "domain": "code.org",
              "url": "/terms-of-service"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "code.org",
          "url": "/students",
          "id": "learn"
        },
        {
          "title": "teach",
          "type": "expander",
          "id": "educate_entries",
          "subentries": [
            {
              "title": "educate_overview",
              "domain": "code.org",
              "url": "/teach",
              "id": "educate-overview"
            },
            {
              "title": "course_catalog",
              "url": "/catalog",
              "domain": "studio.code.org",
              "id": "educate_courses"
            },
            {
              "title": "educate_elementary",
              "domain": "code.org",
              "url": "/educate/curriculum/elementary-school"
            },
            {
              "title": "educate_middle",
              "domain": "code.org",
              "url": "/educate/curriculum/middle-school"
            },
            {
              "title": "educate_high",
              "domain": "code.org",
              "url": "/educate/curriculum/high-school"
            },
            {
              "title": "educate_hoc",
              "url": "https://hourofcode.com"
            },
            {
              "title": "educate_beyond",
              "domain": "code.org",
              "url": "/educate/curriculum/3rd-party"
            },
            {
              "title": "educate_community",
              "url": "https://forum.code.org/"
            },
            {
              "title": "educate_requirements",
              "domain": "code.org",
              "url": "/educate/it"
            },
            {
              "title": "educate_tools",
              "domain": "code.org",
              "url": "/educate/resources/videos"
            }
          ]
        },
        {
          "title": "districts",
          "domain": "code.org",
          "url": "/administrators",
          "id": "districts"
        },
        {
          "title": "stats",
          "domain": "code.org",
          "url": "/promote",
          "id": "stats"
        },
        {
          "title": "donate",
          "domain": "code.org",
          "url": "/donate",
          "id": "donate"
        },
        {
          "title": "incubator",
          "url": "/incubator",
          "domain": "code.org",
          "id": "incubator"
        },
        {
          "title": "about",
          "type": "expander",
          "id": "about_entries",
          "subentries": [
            {
              "title": "about_us",
              "domain": "code.org",
              "url": "/about",
              "id": "about-us"
            },
            {
              "title": "about_leadership",
              "domain": "code.org",
              "url": "/about/leadership"
            },
            {
              "title": "about_donors",
              "domain": "code.org",
              "url": "/about/donors"
            },
            {
              "title": "about_partners",
              "domain": "code.org",
              "url": "/about/partners"
            },
            {
              "title": "about_team",
              "domain": "code.org",
              "url": "/about/team"
            },
            {
              "title": "about_news",
              "domain": "code.org",
              "url": "/about/news"
            },
            {
              "title": "about_jobs",
              "domain": "code.org",
              "url": "/about/jobs"
            },
            {
              "title": "about_contact",
              "domain": "code.org",
              "url": "/contact"
            },
            {
              "title": "about_faqs",
              "domain": "code.org",
              "url": "/faq"
            }
          ]
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "domain": "code.org",
              "url": "/privacy"
            },
            {
              "title": "legal_cookie_notice",
              "domain": "code.org",
              "url": "/cookies"
            },
            {
              "title": "legal_tos",
              "domain": "code.org",
              "url": "/terms-of-service"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "game_lab_documentation",
        "domain": "studio.code.org",
        "level": "Gamelab",
        "url": "/docs/gamelab",
        "id": "gamelab-docs"
      },
      {
        "title": "game_lab_tutorials",
        "domain": "code.org",
        "level": "Gamelab",
        "url": "/educate/gamelab",
        "id": "gamelab-tutorials"
      },
      {
        "title": "app_lab_documentation",
        "domain": "studio.code.org",
        "level": "Applab",
        "url": "/docs/applab",
        "id": "applab-docs"
      },
      {
        "title": "app_lab_tutorials",
        "domain": "code.org",
        "level": "Applab",
        "url": "/educate/applab",
        "id": "applab-tutorials"
      },
      {
        "title": "sprite_lab_documentation",
        "domain": "studio.code.org",
        "level": "Spritelab",
        "url": "/docs/spritelab",
        "id": "spritelab-docs"
      },
      {
        "title": "sprite_lab_tutorials",
        "domain": "code.org",
        "level": "Spritelab",
        "url": "/educate/spritelab",
        "id": "spritelab-tutorials"
      },
      {
        "title": "web_lab_documentation",
        "domain": "studio.code.org",
        "level": "Weblab",
        "url": "/docs/ide/weblab",
        "id": "weblab-docs"
      },
      {
        "title": "help_support",
        "url": "https://support.code.org",
        "id": "support"
      },
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/en-us/requests/new",
        "id": "report-bug"
      },
      {
        "title": "report_abuse",
        "domain": "studio.code.org",
        "url": "/report_abuse",
        "id": "report-abuse"
      },
      {
        "title": "teacher_community",
        "user_type": "teacher",
        "url": "https://forum.code.org",
        "id": "teacher-community"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "/privacy",
          "domain": "code.org",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "/cookies",
          "domain": "code.org"
        },
        {
          "title": "translate",
          "url": "/translate",
          "domain": "code.org"
        },
        {
          "title": "help_support",
          "url": "https://support.code.org",
          "target": "_blank",
          "loc_prefix": "landing.",
          "id": "support"
        },
        {
          "title": "tos_short",
          "url": "/terms-of-service",
          "domain": "code.org"
        }
      ]
    }
  }
} as const;

export const RegionFa = {
  "locales": [
    "fa-IR"
  ],
  "locale_lock": true,
  "countries": [
    "IR"
  ],
  "project_types": [
    "spritelab",
    "artist",
    "applab",
    "gamelab"
  ],
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "teach",
          "id": "header-teach",
          "domain": "code.org",
          "url": "/global/fa/teacher"
        },
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/global/fa/about"
        },
        {
          "title": "csf",
          "id": "header-csf",
          "domain": "code.org",
          "url": "/global/fa/csf"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/fa/hour-of-ai"
        },
        {
          "title": "videos",
          "id": "header-videos",
          "domain": "code.org",
          "url": "/global/fa/videos"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/fa/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/fa/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/fa/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/fa/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/fa/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/fa/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/fa/privacy?_x_tr_sl=auto&_x_tr_tl=fa&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/fa/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=fa&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/fa/terms-of-service?_x_tr_sl=auto&_x_tr_tl=fa&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/fa/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/fa/privacy?_x_tr_sl=auto&_x_tr_tl=fa&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/fa/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=fa&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/fa/terms-of-service?_x_tr_sl=auto&_x_tr_tl=fa&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/ir-fa/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/fa/privacy?_x_tr_sl=auto&_x_tr_tl=fa&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/fa/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=fa&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/fa/terms-of-service?_x_tr_sl=auto&_x_tr_tl=fa&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": [
            "spritelab",
            "artist",
            "applab",
            "gamelab"
          ]
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "fa-IR"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "fa-IR"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/fa/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionFr = {
  "locales": [
    "fr-FR"
  ],
  "locale_lock": true,
  "countries": [
    "FR"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/fr/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/fr/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/fr/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/fr/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/fr/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/fr/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/fr/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/fr/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/fr/privacy?_x_tr_sl=auto&_x_tr_tl=fr-FR&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/fr/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=fr-FR&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/fr/terms-of-service?_x_tr_sl=auto&_x_tr_tl=fr-FR&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/fr/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/fr/privacy?_x_tr_sl=auto&_x_tr_tl=fr-FR&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/fr/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=fr-FR&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/fr/terms-of-service?_x_tr_sl=auto&_x_tr_tl=fr-FR&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/en-us/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/fr/privacy?_x_tr_sl=auto&_x_tr_tl=fr-FR&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/fr/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=fr-FR&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/fr/terms-of-service?_x_tr_sl=auto&_x_tr_tl=fr-FR&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "fr-FR"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "fr-FR"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/fr/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionId = {
  "locales": [
    "id-ID"
  ],
  "locale_lock": true,
  "countries": [
    "ID"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/id/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/id/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/id/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/id/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/id/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/id/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/id/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/id/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/id/privacy?_x_tr_sl=auto&_x_tr_tl=id-ID&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/id/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=id-ID&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/id/terms-of-service?_x_tr_sl=auto&_x_tr_tl=id-ID&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/id/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/id/privacy?_x_tr_sl=auto&_x_tr_tl=id-ID&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/id/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=id-ID&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/id/terms-of-service?_x_tr_sl=auto&_x_tr_tl=id-ID&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/id/privacy?_x_tr_sl=auto&_x_tr_tl=id-ID&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/id/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=id-ID&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/id/terms-of-service?_x_tr_sl=auto&_x_tr_tl=id-ID&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "id-ID"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "id-ID"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/id/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionIn = {
  "locales": [
    "en-IN",
    "hi-IN",
    "ta-IN",
    "te-IN",
    "mr-IN",
    "kn-IN",
    "or-IN",
    "gu-IN"
  ],
  "locale_lock": true,
  "countries": [
    "IN"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/in/en/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/in/en/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/in/en/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/in/en/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/in/en/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/in/en/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "domain": "code.org",
              "url": "/privacy"
            },
            {
              "title": "legal_cookie_notice",
              "domain": "code.org",
              "url": "/privacy/cookies"
            },
            {
              "title": "legal_tos",
              "domain": "code.org",
              "url": "/terms-of-service"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/in/en/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "domain": "code.org",
              "url": "/privacy"
            },
            {
              "title": "legal_cookie_notice",
              "domain": "code.org",
              "url": "/privacy/cookies"
            },
            {
              "title": "legal_tos",
              "domain": "code.org",
              "url": "/terms-of-service"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/en-us/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "domain": "code.org",
          "url": "/privacy",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "domain": "code.org",
          "url": "/privacy/cookies"
        },
        {
          "title": "tos_short",
          "domain": "code.org",
          "url": "/terms-of-service"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "currentLocale": true
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "currentLocale": true
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/in/en/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionIt = {
  "locales": [
    "it-IT"
  ],
  "locale_lock": true,
  "countries": [
    "IT"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/it/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/it/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/it/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/it/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/it/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/it/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/it/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/it/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/it/privacy?_x_tr_sl=auto&_x_tr_tl=it-IT&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/it/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=it-IT&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/it/terms-of-service?_x_tr_sl=auto&_x_tr_tl=it-IT&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/it/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/it/privacy?_x_tr_sl=auto&_x_tr_tl=it-IT&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/it/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=it-IT&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/it/terms-of-service?_x_tr_sl=auto&_x_tr_tl=it-IT&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/it/privacy?_x_tr_sl=auto&_x_tr_tl=it-IT&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/it/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=it-IT&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/it/terms-of-service?_x_tr_sl=auto&_x_tr_tl=it-IT&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "it-IT"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "it-IT"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/it/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionJp = {
  "locales": [
    "ja-JP"
  ],
  "locale_lock": true,
  "countries": [
    "JP"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/jp/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/jp/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/jp/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/jp/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/jp/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/jp/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/en-US/privacy?_x_tr_sl=auto&_x_tr_tl=ja-JP&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/en-US/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=ja-JP&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/en-US/terms-of-service?_x_tr_sl=auto&_x_tr_tl=ja-JP&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/jp/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/en-US/privacy?_x_tr_sl=auto&_x_tr_tl=ja-JP&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/en-US/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=ja-JP&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/en-US/terms-of-service?_x_tr_sl=auto&_x_tr_tl=ja-JP&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/en-US/privacy?_x_tr_sl=auto&_x_tr_tl=ja-JP&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/en-US/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=ja-JP&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/en-US/terms-of-service?_x_tr_sl=auto&_x_tr_tl=ja-JP&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "ja-JP"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "ja-JP"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/jp/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionKr = {
  "locales": [
    "ko-KR"
  ],
  "locale_lock": true,
  "countries": [
    "KR"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/ko/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/ko/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/kr/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/kr/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/kr/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/kr/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/kr/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/kr/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/ko/privacy?_x_tr_sl=auto&_x_tr_tl=ko-KR&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/ko/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=ko-KR&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/ko/terms-of-service?_x_tr_sl=auto&_x_tr_tl=ko-KR&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/kr/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/ko/privacy?_x_tr_sl=auto&_x_tr_tl=ko-KR&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/ko/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=ko-KR&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/ko/terms-of-service?_x_tr_sl=auto&_x_tr_tl=ko-KR&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/ko/privacy?_x_tr_sl=auto&_x_tr_tl=ko-KR&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/ko/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=ko-KR&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/ko/terms-of-service?_x_tr_sl=auto&_x_tr_tl=ko-KR&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "pt-BR"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "pt-BR"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/kr/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionLa = {
  "locales": [
    "es-LA"
  ],
  "locale_lock": true,
  "countries": [
    "MX",
    "CR",
    "SV",
    "GT",
    "HN",
    "NI",
    "PA",
    "CU",
    "DO",
    "PR",
    "AR",
    "BO",
    "CL",
    "CO",
    "EC",
    "PY",
    "PE",
    "UY",
    "VE"
  ],
  "project_types": [
    "spritelab",
    "artist",
    "applab",
    "gamelab"
  ],
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/es/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/es/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/la/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/la/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/la/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/la/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/la/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/la/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/es/privacy?_x_tr_sl=auto&_x_tr_tl=es-MX&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/es/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=es-MX&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/es/terms-of-service?_x_tr_sl=auto&_x_tr_tl=es-MX&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/la/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/es/privacy?_x_tr_sl=auto&_x_tr_tl=es-MX&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/es/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=es-MX&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/es/terms-of-service?_x_tr_sl=auto&_x_tr_tl=es-MX&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/es-la/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/es/privacy?_x_tr_sl=auto&_x_tr_tl=es-MX&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/es/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=es-MX&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/es/terms-of-service?_x_tr_sl=auto&_x_tr_tl=es-MX&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "es-LA"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "es-LA"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/la/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionPl = {
  "locales": [
    "pl-PL"
  ],
  "locale_lock": true,
  "countries": [
    "PL"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/pl/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/pl/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/pl/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/pl/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/pl/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/pl/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/pl/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/pl/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/pl/privacy?_x_tr_sl=auto&_x_tr_tl=pl-PL&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/pl/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=pl-PL&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/pl/terms-of-service?_x_tr_sl=auto&_x_tr_tl=pl-PL&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/pl/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/pl/privacy?_x_tr_sl=auto&_x_tr_tl=pl-PL&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/pl/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=pl-PL&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/pl/terms-of-service?_x_tr_sl=auto&_x_tr_tl=pl-PL&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/pl/privacy?_x_tr_sl=auto&_x_tr_tl=pl-PL&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/pl/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=pl-PL&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/pl/terms-of-service?_x_tr_sl=auto&_x_tr_tl=pl-PL&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "pl-PL"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "pl-PL"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/pl/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionPt = {
  "locales": [
    "pt-PT"
  ],
  "locale_lock": true,
  "countries": [
    "PT"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/pt/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/pt/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/pt/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/pt/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/pt/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/pt/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/en-US/privacy?_x_tr_sl=auto&_x_tr_tl=pt-PT&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/en-US/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=pt-PT&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/en-US/terms-of-service?_x_tr_sl=auto&_x_tr_tl=pt-PT&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/pt/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/en-US/privacy?_x_tr_sl=auto&_x_tr_tl=pt-PT&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/en-US/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=pt-PT&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/en-US/terms-of-service?_x_tr_sl=auto&_x_tr_tl=pt-PT&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/en-US/privacy?_x_tr_sl=auto&_x_tr_tl=pt-PT&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/en-US/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=pt-PT&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/en-US/terms-of-service?_x_tr_sl=auto&_x_tr_tl=pt-PT&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "pt-PT"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "pt-PT"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/pt/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionRo = {
  "locales": [
    "ro-RO"
  ],
  "locale_lock": true,
  "countries": [
    "RO"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/ro/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/ro/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/ro/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/ro/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/ro/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/ro/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/en-US/privacy?_x_tr_sl=auto&_x_tr_tl=ro-RO&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/en-US/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=ro-RO&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/en-US/terms-of-service?_x_tr_sl=auto&_x_tr_tl=ro-RO&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/ro/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/en-US/privacy?_x_tr_sl=auto&_x_tr_tl=ro-RO&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/en-US/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=ro-RO&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/en-US/terms-of-service?_x_tr_sl=auto&_x_tr_tl=ro-RO&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/en-US/privacy?_x_tr_sl=auto&_x_tr_tl=ro-RO&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/en-US/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=ro-RO&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/en-US/terms-of-service?_x_tr_sl=auto&_x_tr_tl=ro-RO&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "ro-RO"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "ro-RO"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/ro/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionRoot = {
  "locales": [
    "en-US"
  ],
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "learn",
          "url": "/students",
          "domain": "code.org",
          "id": "header-learn"
        },
        {
          "title": "teach",
          "url": "/teach",
          "domain": "code.org",
          "id": "header-teach"
        },
        {
          "title": "districts",
          "url": "/administrators",
          "domain": "code.org",
          "id": "header-districts"
        },
        {
          "title": "stats",
          "url": "/promote",
          "domain": "code.org",
          "id": "header-stats"
        },
        {
          "title": "donate",
          "url": "/donate",
          "domain": "code.org",
          "id": "header-donate"
        },
        {
          "title": "incubator",
          "url": "/incubator",
          "domain": "code.org",
          "id": "header-incubator"
        },
        {
          "title": "about",
          "url": "/about",
          "domain": "code.org",
          "id": "header-about"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/students",
          "domain": "code.org",
          "id": "header-student-courses"
        },
        {
          "title": "project_gallery",
          "url": "/projects",
          "domain": "studio.code.org",
          "id": "header-student-projects"
        },
        {
          "title": "incubator",
          "url": "/incubator",
          "domain": "code.org",
          "id": "header-incubator"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "project_gallery",
          "url": "/projects",
          "domain": "studio.code.org",
          "id": "header-teacher-projects"
        },
        {
          "title": "professional_learning",
          "url": "/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        },
        {
          "title": "incubator",
          "url": "/incubator",
          "domain": "code.org",
          "id": "header-teacher-incubator"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "code.org",
          "url": "/students",
          "id": "learn"
        },
        {
          "title": "teach",
          "type": "expander",
          "id": "educate_entries",
          "subentries": [
            {
              "title": "educate_overview",
              "domain": "code.org",
              "url": "/teach",
              "id": "educate-overview"
            },
            {
              "title": "course_catalog",
              "url": "/students",
              "domain": "code.org",
              "id": "educate_courses"
            },
            {
              "title": "educate_elementary",
              "domain": "code.org",
              "url": "/educate/curriculum/elementary-school"
            },
            {
              "title": "educate_middle",
              "domain": "code.org",
              "url": "/educate/curriculum/middle-school"
            },
            {
              "title": "educate_high",
              "domain": "code.org",
              "url": "/educate/curriculum/high-school"
            },
            {
              "title": "educate_hoc",
              "url": "https://hourofcode.com"
            },
            {
              "title": "educate_beyond",
              "domain": "code.org",
              "url": "/educate/curriculum/3rd-party"
            },
            {
              "title": "educate_community",
              "url": "https://forum.code.org/"
            },
            {
              "title": "educate_requirements",
              "domain": "code.org",
              "url": "/educate/it"
            },
            {
              "title": "educate_tools",
              "domain": "code.org",
              "url": "/educate/resources/videos"
            }
          ]
        },
        {
          "title": "districts",
          "domain": "code.org",
          "url": "/administrators",
          "id": "districts"
        },
        {
          "title": "stats",
          "domain": "code.org",
          "url": "/promote",
          "id": "stats"
        },
        {
          "title": "donate",
          "domain": "code.org",
          "url": "/donate",
          "id": "donate"
        },
        {
          "title": "incubator",
          "url": "/incubator",
          "domain": "code.org",
          "id": "incubator"
        },
        {
          "title": "about",
          "type": "expander",
          "id": "about_entries",
          "subentries": [
            {
              "title": "about_us",
              "domain": "code.org",
              "url": "/about",
              "id": "about-us"
            },
            {
              "title": "about_leadership",
              "domain": "code.org",
              "url": "/about/leadership"
            },
            {
              "title": "about_donors",
              "domain": "code.org",
              "url": "/about/donors"
            },
            {
              "title": "about_partners",
              "domain": "code.org",
              "url": "/about/partners"
            },
            {
              "title": "about_team",
              "domain": "code.org",
              "url": "/about/team"
            },
            {
              "title": "about_news",
              "domain": "code.org",
              "url": "/about/news"
            },
            {
              "title": "about_jobs",
              "domain": "code.org",
              "url": "/about/jobs"
            },
            {
              "title": "about_contact",
              "domain": "code.org",
              "url": "/contact"
            },
            {
              "title": "about_faqs",
              "domain": "code.org",
              "url": "/faq"
            }
          ]
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "domain": "code.org",
              "url": "/privacy"
            },
            {
              "title": "legal_cookie_notice",
              "domain": "code.org",
              "url": "/cookies"
            },
            {
              "title": "legal_tos",
              "domain": "code.org",
              "url": "/terms-of-service"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "code.org",
          "url": "/students",
          "id": "learn"
        },
        {
          "title": "teach",
          "type": "expander",
          "id": "educate_entries",
          "subentries": [
            {
              "title": "educate_overview",
              "domain": "code.org",
              "url": "/teach",
              "id": "educate-overview"
            },
            {
              "title": "course_catalog",
              "url": "/catalog",
              "domain": "studio.code.org",
              "id": "educate_courses"
            },
            {
              "title": "educate_elementary",
              "domain": "code.org",
              "url": "/educate/curriculum/elementary-school"
            },
            {
              "title": "educate_middle",
              "domain": "code.org",
              "url": "/educate/curriculum/middle-school"
            },
            {
              "title": "educate_high",
              "domain": "code.org",
              "url": "/educate/curriculum/high-school"
            },
            {
              "title": "educate_hoc",
              "url": "https://hourofcode.com"
            },
            {
              "title": "educate_beyond",
              "domain": "code.org",
              "url": "/educate/curriculum/3rd-party"
            },
            {
              "title": "educate_community",
              "url": "https://forum.code.org/"
            },
            {
              "title": "educate_requirements",
              "domain": "code.org",
              "url": "/educate/it"
            },
            {
              "title": "educate_tools",
              "domain": "code.org",
              "url": "/educate/resources/videos"
            }
          ]
        },
        {
          "title": "districts",
          "domain": "code.org",
          "url": "/administrators",
          "id": "districts"
        },
        {
          "title": "stats",
          "domain": "code.org",
          "url": "/promote",
          "id": "stats"
        },
        {
          "title": "donate",
          "domain": "code.org",
          "url": "/donate",
          "id": "donate"
        },
        {
          "title": "incubator",
          "url": "/incubator",
          "domain": "code.org",
          "id": "incubator"
        },
        {
          "title": "about",
          "type": "expander",
          "id": "about_entries",
          "subentries": [
            {
              "title": "about_us",
              "domain": "code.org",
              "url": "/about",
              "id": "about-us"
            },
            {
              "title": "about_leadership",
              "domain": "code.org",
              "url": "/about/leadership"
            },
            {
              "title": "about_donors",
              "domain": "code.org",
              "url": "/about/donors"
            },
            {
              "title": "about_partners",
              "domain": "code.org",
              "url": "/about/partners"
            },
            {
              "title": "about_team",
              "domain": "code.org",
              "url": "/about/team"
            },
            {
              "title": "about_news",
              "domain": "code.org",
              "url": "/about/news"
            },
            {
              "title": "about_jobs",
              "domain": "code.org",
              "url": "/about/jobs"
            },
            {
              "title": "about_contact",
              "domain": "code.org",
              "url": "/contact"
            },
            {
              "title": "about_faqs",
              "domain": "code.org",
              "url": "/faq"
            }
          ]
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "domain": "code.org",
              "url": "/privacy"
            },
            {
              "title": "legal_cookie_notice",
              "domain": "code.org",
              "url": "/cookies"
            },
            {
              "title": "legal_tos",
              "domain": "code.org",
              "url": "/terms-of-service"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "game_lab_documentation",
        "domain": "studio.code.org",
        "level": "Gamelab",
        "url": "/docs/gamelab",
        "id": "gamelab-docs"
      },
      {
        "title": "game_lab_tutorials",
        "domain": "code.org",
        "level": "Gamelab",
        "url": "/educate/gamelab",
        "id": "gamelab-tutorials"
      },
      {
        "title": "app_lab_documentation",
        "domain": "studio.code.org",
        "level": "Applab",
        "url": "/docs/applab",
        "id": "applab-docs"
      },
      {
        "title": "app_lab_tutorials",
        "domain": "code.org",
        "level": "Applab",
        "url": "/educate/applab",
        "id": "applab-tutorials"
      },
      {
        "title": "sprite_lab_documentation",
        "domain": "studio.code.org",
        "level": "Spritelab",
        "url": "/docs/spritelab",
        "id": "spritelab-docs"
      },
      {
        "title": "sprite_lab_tutorials",
        "domain": "code.org",
        "level": "Spritelab",
        "url": "/educate/spritelab",
        "id": "spritelab-tutorials"
      },
      {
        "title": "web_lab_documentation",
        "domain": "studio.code.org",
        "level": "Weblab",
        "url": "/docs/ide/weblab",
        "id": "weblab-docs"
      },
      {
        "title": "help_support",
        "url": "https://support.code.org",
        "id": "support"
      },
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/en-us/requests/new",
        "id": "report-bug"
      },
      {
        "title": "report_abuse",
        "domain": "studio.code.org",
        "url": "/report_abuse",
        "id": "report-abuse"
      },
      {
        "title": "teacher_community",
        "user_type": "teacher",
        "url": "https://forum.code.org",
        "id": "teacher-community"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "/privacy",
          "domain": "code.org",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "/cookies",
          "domain": "code.org"
        },
        {
          "title": "translate",
          "url": "/translate",
          "domain": "code.org"
        },
        {
          "title": "help_support",
          "url": "https://support.code.org",
          "target": "_blank",
          "loc_prefix": "landing.",
          "id": "support"
        },
        {
          "title": "tos_short",
          "url": "/terms-of-service",
          "domain": "code.org"
        }
      ]
    }
  }
} as const;

export const RegionRu = {
  "locales": [
    "ru-RU"
  ],
  "locale_lock": true,
  "countries": [
    "RU"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/ru/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/ru/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/ru/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/ru/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/ru/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/ru/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/en-US/privacy?_x_tr_sl=auto&_x_tr_tl=ru-RU&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/en-US/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=ru-RU&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/en-US/terms-of-service?_x_tr_sl=auto&_x_tr_tl=ru-RU&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/ru/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/en-US/privacy?_x_tr_sl=auto&_x_tr_tl=ru-RU&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/en-US/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=ru-RU&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/en-US/terms-of-service?_x_tr_sl=auto&_x_tr_tl=ru-RU&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/en-US/privacy?_x_tr_sl=auto&_x_tr_tl=ru-RU&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/en-US/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=ru-RU&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/en-US/terms-of-service?_x_tr_sl=auto&_x_tr_tl=ru-RU&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "ru-RU"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "ru-RU"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/ru/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const RegionSk = {
  "locales": [
    "sk-SK"
  ],
  "locale_lock": true,
  "countries": [
    "SK"
  ],
  "project_types": null,
  "header": {
    "top": {
      "signed_out": [
        {
          "title": "about",
          "id": "header-about",
          "domain": "code.org",
          "url": "/sk/global"
        },
        {
          "title": "hour_of_ai",
          "id": "header-hoa",
          "url": "https://csforall.org/sk/hour-of-ai"
        }
      ],
      "student": [
        {
          "title": "my_dashboard",
          "url": "/sk/home",
          "domain": "studio.code.org",
          "id": "header-student-home"
        },
        {
          "title": "course_catalog",
          "url": "/sk/catalog",
          "domain": "studio.code.org",
          "id": "header-student-courses"
        }
      ],
      "teacher": [
        {
          "title": "my_dashboard",
          "url": "/sk/home",
          "domain": "studio.code.org",
          "id": "header-teacher-home"
        },
        {
          "title": "course_catalog",
          "url": "/sk/catalog",
          "domain": "studio.code.org",
          "id": "header-teacher-courses"
        },
        {
          "title": "professional_learning",
          "url": "/sk/my-professional-learning",
          "domain": "studio.code.org",
          "id": "header-teacher-professional-learning"
        }
      ]
    },
    "hamburger": {
      "student": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/sk/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/sk/privacy?_x_tr_sl=auto&_x_tr_tl=sk-SK&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/sk/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=sk-SK&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/sk/terms-of-service?_x_tr_sl=auto&_x_tr_tl=sk-SK&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ],
      "teacher": [
        {
          "title": "learn",
          "domain": "studio.code.org",
          "url": "/sk/catalog",
          "id": "learn"
        },
        {
          "title": "legal",
          "type": "expander",
          "id": "legal_entries",
          "subentries": [
            {
              "title": "legal_privacy",
              "url": "https://code-org.translate.goog/sk/privacy?_x_tr_sl=auto&_x_tr_tl=sk-SK&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_cookie_notice",
              "url": "https://code-org.translate.goog/sk/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=sk-SK&_x_tr_hl=en&_x_tr_pto=wapp"
            },
            {
              "title": "legal_tos",
              "url": "https://code-org.translate.goog/sk/terms-of-service?_x_tr_sl=auto&_x_tr_tl=sk-SK&_x_tr_hl=en&_x_tr_pto=wapp"
            }
          ]
        }
      ]
    },
    "help": [
      {
        "title": "report_bug",
        "url": "https://support.code.org/hc/requests/new",
        "id": "report-bug"
      }
    ]
  },
  "footer": {
    "links": {
      "studio": [
        {
          "title": "privacy",
          "url": "https://code-org.translate.goog/sk/privacy?_x_tr_sl=auto&_x_tr_tl=sk-SK&_x_tr_hl=en&_x_tr_pto=wapp",
          "style": "color: #ffa400;"
        },
        {
          "title": "cookie_notice",
          "url": "https://code-org.translate.goog/sk/privacy/cookies?_x_tr_sl=auto&_x_tr_tl=sk-SK&_x_tr_hl=en&_x_tr_pto=wapp"
        },
        {
          "title": "tos_short",
          "url": "https://code-org.translate.goog/sk/terms-of-service?_x_tr_sl=auto&_x_tr_tl=sk-SK&_x_tr_hl=en&_x_tr_pto=wapp"
        }
      ]
    }
  },
  "pages": [
    {
      "path": "/",
      "components": {
        "CurriculumCatalog": {
          "forceTranslated": true
        },
        "StartNewProject": {
          "availableProjectTypes": null
        },
        "CurriculumQuickAssign": {
          "courseFilters": {
            "language": "sk-SK"
          }
        },
        "AssignmentVersionSelector": {
          "courseFilters": {
            "language": "sk-SK"
          }
        },
        "TeacherPromotions": false
      }
    },
    {
      "path": "/teacher_dashboard",
      "components": {
        "DownloadParentLetterButton": false,
        "ManageStudentsLoginInfo": {
          "providePrivacyLetter": false
        }
      }
    },
    {
      "path": "/home",
      "components": {
        "MarketingAnnouncementBanner": false,
        "TeacherResources": false,
        "IncubatorBanner": false
      }
    },
    {
      "path": "/users/edit",
      "components": {
        "LtiRosterSyncSettings": false,
        "PersonalLoginDialog": {
          "hideInstructions": true
        },
        "TeacherWarning": {
          "hideInstructions": true
        }
      }
    },
    {
      "path": "/my-professional-learning",
      "components": {
        "LandingPage": {
          "hideMyFacilitatorCenterTab": true,
          "hideInstructorCenterTab": false,
          "hideRPCenterTab": true,
          "hideWorkshopOrganizerCenterTab": true,
          "hideMyPLWorkshopEnrollmentCelebrationDialog": true,
          "hideMyPLBanner": true,
          "hideMyPLSelfPacedPL": false,
          "hideMyPLJoinSectionArea": true,
          "hideMyPLLandingPageWorkshopsTable": true,
          "hideMyPLStaticRecommendedPL": false,
          "hideMyPLStaticRecommendedPLMidHighBlock": true,
          "hideMyPLStaticRecommendedPLSelfPacedBlock": false,
          "myPLStaticRecommendedPLSelfPacedBlockButtonUrl": "/sk/professional-learning/courses"
        }
      }
    }
  ]
} as const;

export const Regions = {
  "ar": RegionAr,
  "br": RegionBr,
  "cn": RegionCn,
  "cz": RegionCz,
  "de": RegionDe,
  "en": RegionEn,
  "fa": RegionFa,
  "fr": RegionFr,
  "id": RegionId,
  "in": RegionIn,
  "it": RegionIt,
  "jp": RegionJp,
  "kr": RegionKr,
  "la": RegionLa,
  "pl": RegionPl,
  "pt": RegionPt,
  "ro": RegionRo,
  "root": RegionRoot,
  "ru": RegionRu,
  "sk": RegionSk,
} as const;

